export default __webpack_public_path__ + "static/media/icon_home.bb14baec.svg";